module.exports = __webpack_public_path__ + "assets/deragopyan.d2eaff28.svg";